<template>
  <div class="containar">
    <div class="clock-contents-block">
      <div>
        <div id="clock" class="content-cl" v-bind:class="fontStyle" v-bind:style="{color: colors.hex}">
          <span class="date" v-bind:class="dateOn">{{ date }}</span>
          <span class="short-time">{{ time }}</span>
        </div>
      </div>
    <div class="set">
      <h3>日付の有無</h3>
      <div class="toggle-group">
        <label class="toggle-option" :class="{ active: hide === 'on' }">
          <input type="radio" value="on" v-model="hide" />
          <span class="toggle-label">日付あり</span>
        </label>
        <label class="toggle-option" :class="{ active: hide === 'off' }">
          <input type="radio" value="off" v-model="hide" />
          <span class="toggle-label">日付なし</span>
        </label>
      </div>
      <h3>カラー選択</h3>
      <div class="color-picker-wrapper">
        <chrome-picker :value="colors" v-model="colors"></chrome-picker>
      </div>
      <h3>フォント選択</h3>
      <div class="font-dropdown-container">
        <div class="custom-font-dropdown" :class="{ open: fontDropdownOpen }">
          <div class="dropdown-selected" @click="toggleFontDropdown">
            <span :class="getCurrentFontClass()" class="selected-font-preview">{{ getCurrentFontName() }}</span>
            <span class="dropdown-arrow">▼</span>
          </div>
          <div class="dropdown-options" v-if="fontDropdownOpen">
            <div v-for="font in fontOptions" :key="font.value" 
                 class="dropdown-option" :class="font.class"
                 @click="selectFont(font.value)">
              <span class="font-preview-text">12:05</span>
              <span class="font-name-small">{{ font.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <h3>配信ソフト用URL</h3>
      <div class="url-description">
        <p>各項目を選択するとURLが自動的に生成されます。</p>
        <p>OBSならば、ソースの「ブラウザ」を追加→下記URLを入力すると表示できます。</p>
      </div>
      <div class="url-container">
        <input :value="urlInput + '?txcolor=' + this.colorsCng + '&font=' + fontsytle + '&hide=' + hide" id="target" type="text" readonly class="url-input" />
        <button @click="copy" class="url-copy-btn">
          <span>コピー</span>
        </button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
      date: "",
      time: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      hide: "on",
      fontsytle:'font0',
      urlInput:'https://ruri.info/tool/shortclockdesign',
      colors: {
        hex: '#194d33',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
        },
      fontDropdownOpen: false,
      fontOptions: [
        { value: 'font0', name: 'Outfit', class: 'font0' },
        { value: 'font2', name: 'Iceland', class: 'font2' },
        { value: 'font3', name: 'Single Day', class: 'font3' },
        { value: 'font5', name: 'Tiny5', class: 'font5' }
      ]
    };
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
    // ドロップダウン外部クリック時の処理
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    updateTime: function () {
      //現在の日付・時刻を取得
      let currentdate = new Date();

      // 現在の時刻
      this.time =
        this.zeroPadding(currentdate.getHours(), 2) +
        ":" +
        this.zeroPadding(currentdate.getMinutes(), 2);
      // this.zeroPadding(currentdate.getSeconds(), 2);

      // 現在の年月日
      this.date =
        this.zeroPadding(currentdate.getMonth() + 1, 2) +
        "/" +
        this.zeroPadding(currentdate.getDate(), 2) +
        " " +
        this.week[currentdate.getDay()];
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.urlInput + '?font=' + this.fontsytle + '&hide=' + this.hide + '&txcolor=' + this.colorsCng)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    toggleFontDropdown() {
      this.fontDropdownOpen = !this.fontDropdownOpen;
    },
    selectFont(fontValue) {
      this.fontsytle = fontValue;
      this.fontDropdownOpen = false;
    },
    getCurrentFontName() {
      const currentFont = this.fontOptions.find(font => font.value === this.fontsytle);
      return currentFont ? currentFont.name : 'Outfit';
    },
    getCurrentFontClass() {
      const currentFont = this.fontOptions.find(font => font.value === this.fontsytle);
      return currentFont ? currentFont.class : 'font0';
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.custom-font-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.fontDropdownOpen = false;
      }
    },
  },
  computed: {
    colorsCng: function(){
        return this.colors.hex.split('#').join('')
    },
    dateOn: function() {
      if (this.hide === 'off') {
        return 'date-off';
      }
      else {
        return '';
      }
    },
    fontStyle: function() {
      if (this.fontsytle === 'font0') {
        return 'font0';
      }
      else if (this.fontsytle === 'font2') {
        return 'font2';
      }
      else if (this.fontsytle === 'font3') {
        return 'font3';
      }
      else if (this.fontsytle === 'font5') {
        return 'font5 font5-manage';
      }
      else {
        return '';
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Klee+One:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Single+Day&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Tiny5&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}


h3{
  font-size: 14px;
  margin-top: 24px;
}


.clock-contents-block{
  text-align: left;
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}

#clock {
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 12px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  color: #fff;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  white-space: nowrap;
}

.short-time {
  letter-spacing: 0em;
  font-size: 80px;
  line-height: 0.9em;
}

.date {
  padding-top: 12px;
  letter-spacing: 0.1em;
  font-size: 24px;
  display: block;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  margin-left:24px
}
.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}



.date-off{
  display:none;
}

.font0{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}


.font2{
  font-family: 'Iceland', cursive;
}
.font3{
  font-family: 'Single Day', cursive;
}

.font5{
  font-family: "Tiny5", serif;
  font-weight: 400;
  font-style: normal;
}
.font5-manage{
  padding-left: 40px !important;
}
/* Toggle Options (日付の有無) */
.toggle-group {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex: 1;
}

.toggle-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.toggle-option.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.2);
  background: #ebf8ff;
}

.toggle-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-label {
  display: block;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: #4a5568;
  transition: color 0.2s ease;
}

.toggle-option.active .toggle-label {
  color: #0f172a;
}

/* Color Picker - Chrome Picker カスタマイズ */
.color-picker-wrapper {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}

.color-picker-wrapper .vc-chrome {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  border: 1px solid #e5e7eb !important;
  font-family: inherit !important;
  width: 240px !important;
}

.color-picker-wrapper .vc-chrome .vc-saturation-wrap {
  border-radius: 6px 6px 0 0 !important;
  overflow: hidden !important;
}

.color-picker-wrapper .vc-chrome .vc-chrome-controls {
  padding: 12px !important;
}

.color-picker-wrapper .vc-chrome .vc-hue,
.color-picker-wrapper .vc-chrome .vc-alpha {
  border-radius: 4px !important;
  height: 12px !important;
}

.color-picker-wrapper .vc-chrome .vc-chrome-fields-wrap {
  border-top: 1px solid #e5e7eb !important;
  padding: 12px !important;
  background: #fafafa !important;
}

.color-picker-wrapper .vc-chrome .vc-chrome-field .vc-input__input {
  box-shadow: 0 0 0 1px #ccc inset !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 6px 8px !important;
  font-size: 12px !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

.color-picker-wrapper .vc-chrome .vc-chrome-field .vc-input__input:focus {
  box-shadow: 0 0 0 2px #0f172a !important;
  outline: none !important;
}

/* Custom Font Dropdown */
.font-dropdown-container {
  margin-top: 12px;
  position: relative;
}

.custom-font-dropdown {
  position: relative;
  width: 100%;
}

.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  background: #ffffff;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-selected:hover {
  box-shadow: 0 0 0 1px #999 inset;
}

.custom-font-dropdown.open .dropdown-selected {
  box-shadow: 0 0 0 2px #0f172a;
}

.selected-font-preview {
  flex: 1;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}

.custom-font-dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #ccc;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
}

.dropdown-option {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.dropdown-option:last-child {
  border-bottom: none;
}

.dropdown-option:hover {
  background-color: #f8f8f8;
}

.font-preview-text {
  font-size: 18px;
  margin-bottom: 2px;
  letter-spacing: 0.05em;
}

.font-name-small {
  font-size: 11px;
  color: #666;
  font-family: system-ui, -apple-system, sans-serif;
}

/* URL Section */
.url-description {
  margin-top: 12px;
}

.url-description p {
  color: #4a5568;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 8px;
}

.url-container {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 13px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  background: #f8f9fa;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
  background: #fff;
}

.url-copy-btn {
  height: 2.4em;
  padding: 0 16px;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}
</style>